import React from 'react';

import QueueTabs from '@totem/components/ticketing/queueTotals/QueueTabs';
import QueueTotalsContainer from '@totem/components/ticketing/queueTotals/QueueTotalsContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const QueueTotalsPage = () => {
  return (
    <ContentLayout>
      <QueueTotalsContainer>
        <IBCard isCovered>
          <QueueTabs />
        </IBCard>
      </QueueTotalsContainer>
    </ContentLayout>
  );
};

export default QueueTotalsPage;
